import { Route } from '@angular/router';
import { RoleGuard } from '@univacity/angular/datas';
import { RoutePath } from '@univacity/shared/types';
import { authRoutes } from './auth/auth.routes';
import { dashboardRoutes } from './dashboard/dashboard.routes';
import { invoicePublicRoutes } from './dashboard/invoice/invoice-public.routes';
import { DashboardLayoutComponent } from './layout/dashboard-layout/dashboard-layout.component';
import { DefaultLayoutComponent } from './layout/default/default-layout.component';
import { pagesRoute } from './pages/pages.routes';
import { programRoutes } from './program/program.routes';
import { quoteRoutes } from './quote/quote.routes';
import { tourRoutes } from './tour/tour.routes';
import { visaRoutes } from './visa/visa.routes';

export const appRoutes: Route[] = [
  {
    path: RoutePath.dashboard.replace('/', ''),
    component: DashboardLayoutComponent,
    canActivateChild: [RoleGuard],
    children: dashboardRoutes,
  },
  {
    path: '',
    component: DefaultLayoutComponent,

    children: [
      ...pagesRoute,
      {
        path: 'auth',
        children: authRoutes,
      },
      {
        path: RoutePath.programs.replace('/', ''),
        children: programRoutes,
      },
      {
        path: RoutePath.tours.replace('/', ''),
        children: tourRoutes,
      },
      {
        path: RoutePath.invoices.replace('/', ''),
        children: invoicePublicRoutes,
      },
      {
        path: RoutePath.payments.replace('/', ''),
        children: quoteRoutes,
      },

      {
        path: RoutePath.organisations.replace('/', ''),
        loadChildren: () =>
          import('./organisation/organisation.module').then(
            (m) => m.InstituteModule
          ),
      },
      {
        path: RoutePath.visa,
        children: visaRoutes,
      },
      {
        path: '',
        pathMatch: 'full',
        loadChildren: () =>
          import('./home/home.module').then((m) => m.HomeModule),
      },
      // {
      //   path: '**',
      //   redirectTo: RoutePath.error.replace('/', ''),
      // },
    ],
  },
];
